module.exports = __webpack_public_path__ + "static/empty.e00a0ae4.png";